<script setup lang="ts">
const props = defineProps<{
	scrapeItem: App.Data.ScrapeItem.ScrapeItemData
}>()

const { user } = useUser()

const form = useForm<App.Data.ScrapeItem.UpdateScrapeItemData>({
	method: 'PUT',
	url: route('products.update', { scrapeItem: props.scrapeItem.uuid }),
	fields: {
		url: props.scrapeItem.full_url,
		competitors: props.scrapeItem.children?.map((competitor) => {
			return {
				uuid: competitor.uuid,
				url: competitor.full_url,
			}
		}) ?? [{ url: '' }],
	},
	errorBag: 'updateScrapeItem',
	reset: false,
})

const deleteForm = useForm({
	method: 'DELETE',
	url: route('products.destroy', { scrapeItem: props.scrapeItem.uuid }),
	fields: {},
	errorBag: 'deleteScrapeItem',
})

const showCompetitorRemoveButton = computed<boolean>(() => form.fields.competitors.length > 1)

function addCompetitor() {
	form.fields.competitors.push({ url: '' })
}

function removeCompetitor(index: number) {
	form.fields.competitors.splice(index, 1)
}
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper>
		<ui-form variant="settings" @submit.prevent="form.submit">
			<ui-form-settings-item>
				<template #label>
					<ui-label for="url">
						{{ t('validation.attributes.url') }}
					</ui-label>
				</template>

				<ui-input
					id="url"
					v-model="form.fields.url"
					autofocus
					type="url"
					class="placeholder:text-muted-foreground/50"
					:placeholder="`${user.current_team?.store_url}/product-url`"
				/>

				<ui-form-error :message="form.errors.url" />
			</ui-form-settings-item>

			<ui-form-settings-item>
				<template #label>
					<ui-label>
						{{ t('validation.attributes.competitor_urls') }}
					</ui-label>
				</template>

				<div class="flex flex-col gap-2">
					<div v-for="(competitor, index) in form.fields.competitors" :key="`competitor_${index}`">
						<div class="flex gap-2">
							<ui-input
								v-model="
									//@ts-ignore
									form.fields.competitors[index].url"
								type="url"
								class="placeholder:text-muted-foreground/50"
								placeholder="https://competitor.com/product-url"
							/>

							<ui-button
								v-if="showCompetitorRemoveButton"
								variant="ghost"
								type="button"
								@click="removeCompetitor(index)"
							>
								<i-ph-x-bold />
							</ui-button>
						</div>

						<template v-if="form.errors.competitors?.hasOwnProperty(index)">
							<ui-form-error
								:message="//@ts-ignore
									form.errors.competitors[index].url as string"
							/>
						</template>
					</div>

					<ui-button
						variant="link"
						class="text-primary"
						type="button"
						@click="addCompetitor"
					>
						<i-ph-plus-bold />
						{{ t('app.buttons.add_competitor') }}
					</ui-button>
				</div>
			</ui-form-settings-item>

			<ui-separator />

			<div class="flex items-center gap-8">
				<ui-button :loading="form.processing" class="w-fit" @click="form.submit">
					{{ t('app.buttons.save') }}
					<template #icon>
						<i-ph-arrow-right />
					</template>
				</ui-button>

				<ui-dialog>
					<ui-dialog-trigger class="text-destructive text-sm">
						{{ t('app.buttons.delete') }}
					</ui-dialog-trigger>

					<ui-dialog-content>
						<ui-dialog-header>
							<ui-dialog-title>
								{{ t('app.delete_scrape_item_dialog_title') }}
							</ui-dialog-title>
						</ui-dialog-header>

						<ui-dialog-description>
							<div>{{ t('app.delete_scrape_item_dialog_text') }}</div>

							<ui-button
								variant="destructive"
								:loading="deleteForm.processing"
								class="mt-4"
								@click="deleteForm.submit"
							>
								{{ t('app.buttons.delete') }}
							</ui-button>
						</ui-dialog-description>

						<ui-dialog-close
							class="ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none"
						>
							<i-ph-x-bold class="size-4" />
						</ui-dialog-close>
					</ui-dialog-content>
				</ui-dialog>
			</div>
		</ui-form>
	</content-wrapper>
</template>
